import {
  useGetJournalProcessingLazyQuery,
  useGetAuditAdjustmentLazyQuery,
  ModuleType,
  DocumentType,
  useGetLetterTemplateByModuleLazyQuery,
  useGetRecurringJournalLazyQuery,
} from 'generated/graphql'
import { useEffect, useState } from 'react'

export const useGLQueries: any = ({ docType, CompanyID, TransactionID }) => {
  const [errMessage, setErrMessage] = useState(null)
  const [errDialog, setErrDialog] = useState(false)

  //----------GL Queries----------//
  const [
    fetchJournalProcessing,
    {
      loading: JournalProcessingLoading,
      called: JournalProcessingCalled,
      data: { getJournalProcessing } = { getJournalProcessing: [] },
    },
  ] = useGetJournalProcessingLazyQuery({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    fetchPolicy: 'network-only',
  })

  const [
    fetchAuditAdjustment,
    {
      loading: AuditAdjustmentLoading,
      called: AuditAdjustmentCalled,
      data: { getAuditAdjustment } = { getAuditAdjustment: [] },
    },
  ] = useGetAuditAdjustmentLazyQuery({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    fetchPolicy: 'network-only',
  })

  const [
    fetchRecurringJournal,
    {
      loading: RecurringJournalLoading,
      called: RecurringJournalCalled,
      data: { getRecurringJournal } = { getRecurringJournal: [] },
    },
  ] = useGetRecurringJournalLazyQuery({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    fetchPolicy: 'network-only',
  })

  let loading,
    called,
    listData,
    subMenuName,
    primaryKey,
    templateBody,
    IsWatermark,
    WatermarkText

  const [
    fetchLetterTemplate,
    {
      loading: LetterTemplateLoading,
      data: { getLetterTemplateByModule } = { getLetterTemplateByModule: {} },
    },
  ] = useGetLetterTemplateByModuleLazyQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  switch (docType) {
    case 'journal-processing':
      loading = JournalProcessingLoading
      called = JournalProcessingCalled
      listData = getJournalProcessing
      subMenuName = 'Journal Entries'
      primaryKey = 'JournalProcessingID'
      templateBody = getLetterTemplateByModule?.TemplateBody ?? ''
      IsWatermark = getLetterTemplateByModule?.IsWatermark ?? false
      WatermarkText = getLetterTemplateByModule?.WatermarkText ?? ''

      break

    case 'recurring-journal':
      loading = RecurringJournalLoading
      called = RecurringJournalCalled
      listData = getRecurringJournal
      subMenuName = 'Recurring Journal Entries'
      primaryKey = 'RecurringJournalID'
      templateBody = getLetterTemplateByModule
      break

    case 'audit-adjustment':
      loading = AuditAdjustmentLoading
      called = AuditAdjustmentCalled
      listData = getAuditAdjustment
      subMenuName = 'Audit Adjustment Entries'
      primaryKey = 'AuditAdjustmentID'
      templateBody = getLetterTemplateByModule?.TemplateBody ?? ''
      IsWatermark = getLetterTemplateByModule?.IsWatermark ?? false
      WatermarkText = getLetterTemplateByModule?.WatermarkText ?? ''

      break
  }

  useEffect(() => {
    switch (docType) {
      case 'journal-processing':
        fetchJournalProcessing({
          variables: { JournalProcessingID: TransactionID, CompanyID },
        })
        fetchLetterTemplate({
          variables: {
            LetterCategory: ModuleType.Gl,
            LetterType: DocumentType.JournalProcessing,
            CompanyID,
          },
        })
        break

      case 'audit-adjustment':
        fetchAuditAdjustment({
          variables: { AuditAdjustmentID: TransactionID, CompanyID },
        })
        fetchLetterTemplate({
          variables: {
            LetterCategory: ModuleType.Gl,
            LetterType: DocumentType.AuditAdjustment,
            CompanyID,
          },
        })
        break
      case 'recurring-journal':
        fetchRecurringJournal({
          variables: { RecurringJournalID: TransactionID, CompanyID },
        })
        fetchLetterTemplate({
          variables: {
            LetterCategory: ModuleType.Gl,
            LetterType: DocumentType.RecurringJournal,
            CompanyID,
          },
        })
    }
  }, [docType])

  return {
    loading,
    called,
    listData,
    subMenuName,
    primaryKey,
    errMessage,
    errDialog,
    setErrDialog,
    LetterTemplateLoading,
    templateBody,
    IsWatermark,
    WatermarkText,
  }
}
